/**
 * Step Response — the running-sum counterpart of Impulse Response (see
 * `./impulse-response.ts` for the shared reasoning: same geometry function,
 * `mode: 'step'` instead of `'impulse'`). Kept as its own file/PAD constant
 * per chart id, matching every other registry entry in this directory.
 */
import { computeImpulseResponseGeometry, type ImpulseResponseOptions } from '../impulseResponse';
import type { ChartPad } from '../layout';
import { setupCanvas, drawEmptyMessage, drawLinearAxisGrid, drawSeriesLine, INK } from './_shared';

export const STEP_RESPONSE_PAD: ChartPad = { t: 10, r: 14, b: 20, l: 34 };

export interface DrawStepResponseOpts {
  freqs: number[];
  mag: number[];
  phase: number[];
  width: number;
  height: number;
  options?: ImpulseResponseOptions;
}

export function drawStepResponseCanvas(canvas: HTMLCanvasElement, opts: DrawStepResponseOpts): void {
  const s = setupCanvas(canvas, opts.width, opts.height);
  if (!s) return;
  const { ctx, W, H } = s;

  const geo = computeImpulseResponseGeometry({
    freqs: opts.freqs,
    mag: opts.mag,
    phase: opts.phase,
    width: opts.width,
    height: opts.height,
    pad: STEP_RESPONSE_PAD,
    mode: 'step',
    options: opts.options,
  });

  if (geo.empty) {
    drawEmptyMessage(ctx, W, H, 'No phase data yet');
    return;
  }

  drawLinearAxisGrid(ctx, geo.frame, geo.xTicks, geo.yTicks);
  drawSeriesLine(ctx, geo.frame, geo.points, INK.primary, 1.6);
}
